import { Message, ReceivedViaChannel } from '../hooks/useChat'

export interface ChannelBadgeInfo {
  icon: string
  label: string
  shortPhone: string
  fullPhone: string
  provider: string
  color: string
  backgroundColor: string
}

export const getChannelBadgeInfo = (message: Message): ChannelBadgeInfo | null => {
  if (!message.received_via_channel) return null

  const channel = message.received_via_channel
  const last4 = channel.phone_number.slice(-4)
  const providerLabel = getProviderLabel(channel.provider)

  return {
    icon: channel.channel_type === 'WHATSAPP' ? 'bi-whatsapp' : 'bi-chat-dots',
    label: channel.channel_type === 'WHATSAPP' ? 'WA' : 'SMS',
    shortPhone: `••••${last4}`,
    fullPhone: channel.phone_number,
    provider: channel.provider,
    color: channel.channel_type === 'WHATSAPP' ? '#25d366' : '#3e97ff',
    backgroundColor: channel.channel_type === 'WHATSAPP' ? '#dcf8c6' : '#e3f2fd',
  }
}

export const getProviderLabel = (provider: string): string => {
  const map: Record<string, string> = {
    TWILIO: 'Twilio',
    BOTMAKER: 'Botmaker',
    META: 'Meta',
  }
  return map[provider] || provider
}

export const getChannelBadgeTooltip = (message: Message): string => {
  if (!message.received_via_channel) return ''
  const channel = message.received_via_channel
  return `${getProviderLabel(channel.provider)} ${channel.channel_type} ${channel.phone_number}`
}
